<template>
  <!-- 模板部分 -->
  <el-container class="layout-container">
    <!-- 顶部导航栏 -->
    <el-header height="60px" class="header">
      <div class="header-left">
        <div class="logo">
          <img src="../../src/assets/image/dist/img/logy.png" alt="logo" class="logo-img" />
        </div>
        <div class="nav-actions">
          <el-button
            type="text"
            class="toggle-button"
            :icon="isAsideCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            @click="toggleAside"
          >
            {{ isAsideCollapsed ? '展开菜单' : '隐藏菜单' }}
          </el-button>
          <el-button
            type="text"
            class="toggle-button"
            icon="el-icon-back"
            @click="goBack"
            :disabled="isPublicFromUrl"
          >返回上一页</el-button>
          <el-button
            type="text"
            class="toggle-button"
            icon="el-icon-s-home"
            @click="Back"
            :disabled="isPublicFromUrl"
          >返回首页</el-button>
          <el-button type="text" class="nav-button" @click="goToUserHelp">用户帮助</el-button>
          <!-- 根据是否登录决定是否显示登录按钮 -->
          <el-button 
            v-if="!isLoggedIn" 
            type="text" 
            class="nav-button" 
            @click="$router.push('/login')"
          >
            登录
          </el-button>
        </div>
      </div>

      <div class="header-right">
        <el-switch
          v-model="isDataPublic"
          @change="handleDataPrivacyChange"
          :disabled="isPublicFromUrl"
        ></el-switch>
        <span v-if="!isLoading &&!hasError" style="margin-left: 10px" class="but">
          当前数据隐私状态为：{{ isDataPublic ? '公开' : '保密' }}
          <span v-if="isDataPublic">，复制这个链接：<a :href="publicLink" target="_blank">{{ publicLink }}</a></span>
        </span>
        <el-alert v-if="hasError" type="error" message="数据加载失败，请刷新重试" show-icon></el-alert>

        <el-dropdown v-if="isLoggedIn" @command="handleCommand">
          <span class="el-dropdown-link">
            <i class="el-icon-user-solid avatar-icon"></i>
            <span>{{ userInfo.user_name || '未知用户' }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout" :disabled="isPublicFromUrl">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 二级容器：左侧导航 + 主内容 -->
    <el-container>
      <el-aside :width="isAsideCollapsed ? '0px' : '220px'" class="aside">
        <el-menu
          :default-active="$route.path"
          background-color="#fff8eb"
          text-color="#355e3b"
          active-text-color="#1b3520"
          unique-opened
          router
        >
          <el-menu-item :index="getMenuItemIndex('/system/total-list')">
            <i class="el-icon-s-data"></i>
            <span slot="title" style="font-weight: bold;">{{ compoundListTitle || '原始搜库列表' }}</span>
          </el-menu-item>

          <el-submenu index="compound">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span slot="title" style="font-weight: bold;">鉴定结果表</span>
            </template>
            <el-menu-item :index="getMenuItemIndex('/system/compound-list/calcium')">鉴定结果表</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/compound-list/barium')">{{ aMaterialTitle || 'A' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/compound-list/spironolactone')">{{ bMaterialTitle || 'B' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/compound-list/amantadine')">{{ cMaterialTitle || 'C' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/compound-list/ephedrine')">{{ dMaterialTitle || 'D' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/compound-list/unfinished')">{{ notMatchedTitle || '未匹配化合物' }}</el-menu-item>
          </el-submenu>

          <el-submenu index="compounds">
            <template slot="title">
              <i class="el-icon-s-grid"></i>
              <span slot="title" style="font-weight: bold;">中药成分表</span>
            </template>
            <el-menu-item :index="getMenuItemIndex('/system/component-list/cal')">{{ componentListTitle || '中药成分表' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/component-list/bari')">{{ aComponentTitle || 'A' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/component-list/spiro')">{{ bComponentTitle || 'B' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/component-list/aman')">{{ cComponentTitle || 'C' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/component-list/ephe')">{{ dComponentTitle || 'D' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/component-list/unfin')">{{ notMatchedComponentTitle || '未匹配化合物' }}</el-menu-item>
          </el-submenu>

          <el-submenu index="input">
            <template slot="title">
              <i class="el-icon-s-order"></i>
              <span slot="title" style="font-weight: bold;">入靶列表</span>
            </template>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/pre-register')">{{ allCompoundTitle || '入血成分' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/possible-input')">{{ aCompoundTitle || '入血成分前体注释' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/substitute')">{{ bCompoundTitle || '可能入血成分' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/substitute-pre-register')">{{ cCompoundTitle || '可能代谢物' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/drug-compound')">{{ dCompoundTitle || '可能代谢物前体注释' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/experimental-compound')">{{ eCompoundTitle || '药物化合物' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/test-compound')">{{ fCompoundTitle || '实验组化合物' }}</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/input-list/control-compound')">{{ gCompoundTitle || '对照组化合物' }}</el-menu-item>
          </el-submenu>

          <el-submenu index="network">
            <template slot="title">
              <i class="el-icon-share"></i>
              <span slot="title" style="font-weight: bold;">分子网络图</span>
            </template>
            <el-menu-item :index="getMenuItemIndex('/system/network/network1')">正模式分子网络</el-menu-item>
            <el-menu-item :index="getMenuItemIndex('/system/network/network2')">负模式分子网络</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>

      <!-- 主内容 -->
      <el-main class="main">
        <router-view></router-view>
      </el-main>

    </el-container>
  </el-container>
</template>
<script>
import axios from 'axios';
import { DebugHelper } from '../utils/debugHelper.js';

export default {
  name: 'MainLayout',
  data() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    return {
      isAsideCollapsed: false,
      userInfo,
      compoundListTitle: null,
      totalMaterialTitle: null,
      aMaterialTitle: null,
      bMaterialTitle: null,
      cMaterialTitle: null,
      dMaterialTitle: null,
      notMatchedTitle: null,
      componentListTitle: null,
      aComponentTitle: null,
      bComponentTitle: null,
      cComponentTitle: null,
      dComponentTitle: null,
      notMatchedComponentTitle: null,
      allCompoundTitle: null,
      aCompoundTitle: null,
      bCompoundTitle: null,
      cCompoundTitle: null,
      dCompoundTitle: null,
      eCompoundTitle: null,
      fCompoundTitle: null,
      gCompoundTitle: null,
      isDataPublic: false,
      isLoading: true,
      hasError: false,
      isPublicFromUrl: false,
      publicLink: '',
      isLoggedIn: !!localStorage.getItem('token') 
    };
  },
  async created() {
    await this.checkProjectStatus();
    const projectId = this.$route.query.id;
    this.isLoggedIn = !!localStorage.getItem('token'); 
    this.isPublicFromUrl = this.$route.query.isPublic === 'true';
    const isPublic = this.isPublicFromUrl;
    if (projectId) {
      try {
        const response = await axios.get('api/get-project-status', { params: { projectId, isPublic } });
        if (response.data && typeof response.data.data.is_public === 'number') {
          const apiIsPublic = response.data.data.is_public === 1;
          this.isDataPublic = apiIsPublic;
          this.generatePublicLink(projectId);
          if (this.isPublicFromUrl && !apiIsPublic) {
            this.handleInvalidPublicLink(projectId);
          }
        } else {
          console.error('接口返回数据格式不正确，未找到有效的 is_public 字段:', response.data);
          this.hasError = true;
          console.warn('项目状态检查失败，但继续加载页面');
        }

        const commonParams = { project_id: projectId, isPublic };

        const [
          compoundResponse,
          totalMaterialResponse,
          aMaterialResponse,
          bMaterialResponse,
          cMaterialResponse,
          dMaterialResponse,
          notMatchedResponse,
          allCompoundResponse,
          aCompoundResponse,
          bCompoundResponse,
          cCompoundResponse,
          dCompoundResponse,
          eCompoundResponse,
          fCompoundResponse,
          gCompoundResponse
        ] = await Promise.all([
          axios.get('api/show-all-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/total-material', { params: commonParams, timeout: 5000 }),
          axios.get('api/a-material', { params: commonParams, timeout: 5000 }),
          axios.get('api/b-material', { params: commonParams, timeout: 5000 }),
          axios.get('api/c-material', { params: commonParams, timeout: 5000 }),
          axios.get('api/d-material', { params: commonParams, timeout: 5000 }),
          axios.get('/api/not-matched', { params: commonParams, timeout: 5000 }),
          axios.get('api/all-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/a-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/b-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/c-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/d-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/e-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/f-compound', { params: commonParams, timeout: 5000 }),
          axios.get('api/g-compound', { params: commonParams, timeout: 5000 })
        ]);

        this.compoundListTitle = this.extractTitle(compoundResponse.data) || '原始搜库列表';
        this.totalMaterialTitle = this.extractTitle(totalMaterialResponse.data) || '鉴定结果表';
        this.aMaterialTitle = this.extractTitle(aMaterialResponse.data) || 'A';
        this.bMaterialTitle = this.extractTitle(bMaterialResponse.data) || 'B';
        this.cMaterialTitle = this.extractTitle(cMaterialResponse.data) || 'C';
        this.dMaterialTitle = this.extractTitle(dMaterialResponse.data) || 'D';
        this.notMatchedTitle = this.extractTitle(notMatchedResponse.data) || '未匹配化合物';
        this.componentListTitle = '中药成分表';
        this.aComponentTitle = this.extractTitle(aMaterialResponse.data) || 'A';
        this.bComponentTitle = this.extractTitle(bMaterialResponse.data) || 'B';
        this.cComponentTitle = this.extractTitle(cMaterialResponse.data) || 'C';
        this.dComponentTitle = this.extractTitle(dMaterialResponse.data) || 'D';
        this.notMatchedComponentTitle = this.extractTitle(notMatchedResponse.data) || '未匹配化合物';
        this.allCompoundTitle = this.extractTitle(allCompoundResponse.data) || '入血成分';
        this.aCompoundTitle = this.extractTitle(aCompoundResponse.data) || '入血成分前体注释';
        this.bCompoundTitle = this.extractTitle(bCompoundResponse.data) || '可能入血成分';
        this.cCompoundTitle = this.extractTitle(cCompoundResponse.data) || '可能代谢物';
        this.dCompoundTitle = this.extractTitle(dCompoundResponse.data) || '可能代谢物前体注释';
        this.eCompoundTitle = this.extractTitle(eCompoundResponse.data) || '药物化合物';
        this.fCompoundTitle = this.extractTitle(fCompoundResponse.data) || '实验组化合物';
        this.gCompoundTitle = this.extractTitle(gCompoundResponse.data) || '对照组化合物';
      } catch (error) {
        if (axios.isCancel(error)) {
          console.error('请求被取消:', error.message);
        } else if (error.code === 'ECONNABORTED') {
          console.error('请求超时:', error.message);
        } else {
          console.error('请求失败:', error.message);
        }
        this.compoundListTitle = '原始搜库列表';
        this.totalMaterialTitle = '鉴定结果表';
        this.aMaterialTitle = 'A';
        this.bMaterialTitle = 'B';
        this.cMaterialTitle = 'C';
        this.dMaterialTitle = 'D';
        this.notMatchedTitle = '未匹配化合物';
        this.componentListTitle = '中药成分表';
        this.aComponentTitle = 'A';
        this.bComponentTitle = 'B';
        this.cComponentTitle = 'C';
        this.dComponentTitle = 'D';
        this.notMatchedComponentTitle = '未匹配化合物';
        this.allCompoundTitle = '入血成分';
        this.aCompoundTitle = '入血成分前体注释';
        this.bCompoundTitle = '可能入血成分';
        this.cCompoundTitle = '可能代谢物';
        this.dCompoundTitle = '可能代谢物前体注释';
        this.eCompoundTitle = '药物化合物';
        this.fCompoundTitle = '实验组化合物';
        this.gCompoundTitle = '对照组化合物';
        this.hasError = true;
      } finally {
        this.isLoading = false;
      }
    } else {
      this.isLoading = false;
    }
  },
  watch: {
    '$route'(to, from) {
      DebugHelper.logRouteChange(from, to);
      this.checkProjectStatus();
    }
  },
  methods: {
    goToUserHelp() {
      window.open(this.$router.resolve('/help').href, '_blank');
    },
    toggleAside() {
      this.isAsideCollapsed = !this.isAsideCollapsed;
    },
    async handleDataPrivacyChange(val) {
      if (this.isPublicFromUrl) {
        this.$message.warning('公开访问状态下不能切换数据隐私状态');
        return;
      }
      console.log(`数据隐私状态已切换为：${val ? '公开' : '保密'}`);
      try {
        const projectId = this.$route.query.id;
        await axios.post('api/change-project', {
          projectId,
          isPublic: val
        });
        this.$message.success(`数据状态已切换为：${val ? '公开' : '保密'}`);
        this.isDataPublic = val;
        this.generatePublicLink(projectId);

        let newPath;
        if (val) { 
          newPath = `/system/total-list?id=${projectId}`;
        } else { 
          newPath = `/system/total-list?id=${projectId}`;
          if (this.isPublicFromUrl) {
            this.$router.push(newPath);
          }
        }

        if (this.$route.fullPath!== newPath) {
          this.$router.push(newPath).catch((error) => {
            if (error.name === 'NavigationDuplicated') {
              console.log('Navigation to the same route was prevented.');
            } else {
              throw error;
            }
          });
        }
      } catch (error) {
        console.error('切换数据隐私状态失败:', error);
        this.$message.error('切换数据隐私状态失败，请稍后重试');
        this.isDataPublic = !val;
      }
    },
    generatePublicLink(projectId) {
      this.publicLink = `${window.location.origin}${this.$router.resolve({
        path: '/system/total-list',
        query: { id: projectId, isPublic: true }
      }).href}`;
    },
    extractTitle(responseData) {
      if (
        responseData &&
        responseData.data &&
        Array.isArray(responseData.data.data) &&
        responseData.data.data.length > 0 &&
        responseData.data.data[0].spectrum_image
      ) {
        let name = responseData.data.data[0].spectrum_image;
        if (name.endsWith('.xlsx')) {
          name = name.slice(0, -5);
        }
        return name;
      }
      console.warn('未找到有效的 spectrum_image 字段');
      return null;
    },
    async handleCommand(command) {
      if (this.isPublicFromUrl) {
        this.$message.warning('公开访问状态下不能退出登录');
        return;
      }
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            await axios.post('api/logout', {
              token: localStorage.getItem('token')
            });
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            this.$router.push('/login');
            this.$message({
              type: 'success',
              message: '退出登录成功'
            });
            this.isLoggedIn = false; 
          } catch (error) {
            console.error('退出登录失败:', error);
            this.$message({
              type: 'error',
              message: '退出登录失败，请稍后重试'
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录'
          });
        });
      }
    },
    getMenuItemIndex(basePath) {
      const projectId = this.$route.query.id;
      if (projectId) {
        const shouldAddIsPublic = !this.isLoggedIn && this.isDataPublic;
        if (shouldAddIsPublic) {
          return `${basePath}?id=${projectId}&isPublic=true`;
        } else {
          return `${basePath}?id=${projectId}`;
        }
      }
      return basePath;
    },
    goBack() {
      if (this.isPublicFromUrl) {
        this.$message.warning('公开访问状态下不能返回上一页');
        return;
      }
      this.$router.go(-1);
    },
    Back() {
      if (this.isPublicFromUrl) {
        this.$message.warning('公开访问状态下不能返回首页');
        return;
      }
      const adminValue = this.userInfo.is_admin;
      if (adminValue === 1) {
        this.$router.push('/project/compound-list/bar'); 
      } else {
        this.$router.push('/project-list');
      }
    },
    async checkProjectStatus(projectId = this.$route.query.id) {
      this.isPublicFromUrl = this.$route.query.isPublic === 'true';
      if (projectId) {
        try {
          const response = await axios.get('api/get-project-status', { params: { projectId, isPublic: this.isPublicFromUrl } });
          if (response.data && typeof response.data.data.is_public === 'number') {
            const isPublic = response.data.data.is_public === 1;
            if (this.isPublicFromUrl && !isPublic) {
              this.handleInvalidPublicLink(projectId);
              return;
            }
            if (isPublic && !this.isPublicFromUrl && !this.isLoggedIn) {
              this.$message.warning('正在重定向到公开访问链接');
              this.$router.push({
                path: '/system/total-list',
                query: { id: projectId, isPublic: true }
              });
              return;
            }
            if (!this.isPublicFromUrl && !isPublic) {
              const isLoggedIn = !!localStorage.getItem('token');
              if (!isLoggedIn) {
                this.$message.warning('数据为保密状态，请先登录');
                this.$router.push('/login').then(() => {
                  console.log('跳转到登录页面');
                }).catch((error) => {
                  console.error('跳转失败:', error);
                });
              }
            } 
          } else {
            console.error('接口返回数据格式不正确，未找到有效的 is_public 字段:', response.data);
            console.warn('项目状态检查失败，但继续加载页面');
          }
        } catch (error) {
          console.error('获取项目状态失败:', error);
          console.warn('项目状态检查失败，但继续加载页面。错误详情:', error.message);
          if (error.response && error.response.status >= 500) {
            console.warn('服务器错误，允许继续访问');
            return;
          }
          if (error.response && error.response.status === 401) {
            this.$message.warning('需要登录才能访问此页面');
            this.$router.push('/login');
          }
        }
      }
    },
    handleInvalidPublicLink(projectId) {
      this.$message.error('无效的公开访问链接：该项目已设置为保密状态或链接参数被修改');
      console.warn(`检测到无效的公开访问尝试：项目ID ${projectId}，URL参数：`, this.$route.query);
      this.$router.push('/login');
    }
  }
};
</script>
<style scoped>
.layout-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.el-dropdown-link{
  color: white;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: url('../../src/assets/image/dist/img/list1.png');
  background-size: cover;
  color: white;
  padding: 0 20px;
  height: 60px;
}
.nav-actions{
  margin-left: 40px;
}
.logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 40px;
}

.toggle-button {
  color: white;
  margin-left: 10px;
}

.header-left,
.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar-icon {
  margin-right: 4px;
}

.el-container {
  flex: 1;
  height: calc(100vh - 60px);
}

.aside {
  background: url('../../src/assets/image/dist/img/list2.png');
  background-size: cover;
}

.main {
  background: url('../../src/assets/image/dist/img/list.png');
  background-size: cover;
}

.but{
  margin-right: 100px;
}

.nav-button {
  font-size: 14px;
  color: #ffffff;
}

.el-button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.el-switch[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}

.el-dropdown-item[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>